/**
 * The sky behind every menu (docs/spec/04 §6): one starfield for all of them, so opening Options
 * from the title does not jolt the stars. Only the scene on top is updated, so it moves once a frame.
 */

import { BLACK } from '../../render/palette';
import type { Screen } from '../../render/screen';
import { Starfield } from '../../render/starfield';

let stars: Starfield | null = null;

/** The menus' starfield, made on first use. */
export function menuStars(): Starfield {
  stars ??= new Starfield();
  return stars;
}

/**
 * Black, the stars, and over them a veil of black `veil` deep (0-1) for screens full of text.
 * `deep` and `calm` are the Deep starfield and Reduce flashing settings.
 */
export function drawBackdrop(screen: Screen, deep: boolean, calm: boolean, veil = 0): void {
  screen.clear(BLACK);
  menuStars().draw(screen, deep, calm);
  if (veil > 0) screen.faded(veil, () => screen.fill(0, 0, screen.width, screen.height, BLACK));
}
